<template>
  <base-modal :box="box_init" :step="step">
    <div></div>
  </base-modal>
</template>

<script>
  import BaseModal from '../../../_base/index';
  import { StepMixin } from '../../../_base/step-mixin';

  /**
   * props.box - автоматически прокидывается в form
   * чтобы сохранить состояние шага, используй mixin_save_step из StepMixin
   */

  export default {
    components: { BaseModal },
    mixins: [StepMixin],

    methods: {
      save: function () {
        this.$refs.form.validate().then((is_valid) => {
          if (is_valid) {
            const box = this.mixin_get_box(this.form);
            this.$emit('on-save', box);
          }
        });
      },

      set_create_number_step() {
        this.mixin_save_step(this.form);
        this.mixin_set_step('create-number');
      }
    }
  };
</script>
